// extracted by mini-css-extract-plugin
export default {"pdfIcon":"MZ48LDPOlEuXxOIYqs6E"};